export function canCreateReferencePackFromSummary({
  viewerIsModel,
}: {
  viewerIsModel: boolean;
  viewerIsHost: boolean;
}) {
  return viewerIsModel;
}
